
const AdminProfile = {
  TRIMBLE_ADMIN: 1,
  ADMIN: 2,
  BI_ADMIN: 1216
};

class DevicesCtrl {
  constructor($safetyService, $window, Authenticator, FeatureOuService, $state, UrlService, FeaturehubJsSdk, FeatureHubConfigKeys) {
    this.window = $window;
    this.safetyService = $safetyService;
    this.authenticator = Authenticator;
    this.FeatureOuService = FeatureOuService;
    this.featurehubJsSdk = FeaturehubJsSdk;
    this.featureHubConfigKeys = FeatureHubConfigKeys;
    this.state = $state;
    this.urlService = UrlService;
    this.queryParams = this.urlService.parseQueryParams(this.window.location.search);
    this.isFeatureHideTitleEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.ORION_HIDE_TITLE);
    if (this.isFeatureHideTitleEnabled && this.queryParams.hideTitle === 'true') {
      this.hideTitle = true;
    } else {
      this.hideTitle = false;
    }
    this.initializePage();
  }

  initializePage() {
    this.safetyService.initialize()
      .then(() => this.loadPage())
      .catch(error => this.log.error('Initialization failed:', error));
  }

  loadPage() {
    let isAdmin = false,
        userProps = [];
    this.authenticator.getUser()
      .then(user => {
        this.FeatureOuService.getDeviceScreenConfig(user.uo.id).then((eventNaConfig) => {
          if (!eventNaConfig) {
            this.state.go('root.unauthorized');
          }
        }).catch((error) => {
          this.log.error('Error loading featureOu config: ', error);
        });
        if (user.perfil && user.perfil.id) {
          isAdmin = [AdminProfile.TRIMBLE_ADMIN, AdminProfile.ADMIN, AdminProfile.BI_ADMIN].includes(user.perfil.id);
        }
        userProps = user;
        const appName = 'safetyApp',
            componentPath = './DevicePageRoute',
            componentId = 'safety-app',
            props = {
              isAdmin: isAdmin,
              user: userProps,
              hideTitle: this.hideTitle,
              dvrNumber: this.state.params.dvr
            };
        return this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
      });
  }
}
DevicesCtrl.$inject = ['safetyService', '$window', 'Authenticator', 'FeatureOuService', '$state', 'UrlService', 'FeaturehubJsSdk', 'FeatureHubConfigKeys'];
angular.module('cadastros.devices').controller('DevicesCtrl', DevicesCtrl);
